import { Button } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { cn } from "@/shared/lib/utils";

interface AuthSubmitButtonProps {
  loading?: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  onClick?: () => void;
  htmlType?: "submit" | "button";
  className?: string;
}

export function AuthSubmitButton({
  loading = false,
  disabled = false,
  children,
  onClick,
  htmlType = "submit",
  className,
}: AuthSubmitButtonProps) {
  return (
    <Button
      htmlType={htmlType}
      // While loading: no second submit (click or Enter), same look as idle.
      onClick={(event) => {
        if (loading) {
          event.preventDefault();
          return;
        }
        onClick?.();
      }}
      disabled={loading ? false : disabled}
      aria-busy={loading || undefined}
      block
      className={cn(
        "relative !h-auto !rounded-[14px] !border-none !py-3 !text-sm !font-semibold !text-white !transition-all !duration-200 !ease-out hover:!opacity-80",
        loading && "!pointer-events-none",
        className,
      )}
      style={{ backgroundColor: "rgba(228, 0, 43, 0.5)" }}
    >
      {/* Busy: faded under a light white veil (like a disabled button); the spinner stays bright on top. */}
      {loading && <span aria-hidden="true" className="pointer-events-none absolute -inset-px z-[1] rounded-[inherit] bg-white/45" />}
      {/* The label never moves: the spinner fades in just left of it, floating
          (absolute), instead of antd's loading icon pushing the text right. */}
      <span className="relative inline-flex items-center">
        <span
          aria-hidden="true"
          className={cn(
            "pointer-events-none absolute right-full z-[2] mr-2 flex items-center transition-opacity duration-200 ease-out [filter:drop-shadow(0_0_1.5px_rgba(10,41,71,0.55))]",
            loading ? "opacity-100" : "opacity-0",
          )}
        >
          {loading && <LoadingOutlined spin />}
        </span>
        {children}
      </span>
    </Button>
  );
}
